import {read, utils, write} from 'xlsx';
import {saveAs} from 'file-saver';
import moment from 'moment';

interface ReadOpts {
  startRow?: number
}

export class XlsxService {

  static readExcelFile(file: any, opts?: ReadOpts): Promise<any> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = event => {
        if (event && event.target && event.target.result) {
          const wb = read(event.target.result);

          const sheet2JSONOpts: any = {
            header: 1
          };
          if (opts?.startRow) {
            const range = utils.decode_range(wb.Sheets[wb.SheetNames[0]]['!ref']);
            range.s.r = opts.startRow;
            sheet2JSONOpts.range = utils.encode_range(range);
          }

          const data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], sheet2JSONOpts);
          resolve(data);
        } else {
          resolve([]);
        }
      }
      reader.onerror = () => {
        resolve([]);
      }
      reader.readAsArrayBuffer(file);
    });
  }

  static generateFile = (aoa, fileName) => {
    const worksheet = utils.aoa_to_sheet(aoa);
    const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer = write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  static saveAsExcelFile(buffer, fileName) {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
      type: EXCEL_TYPE
    });

    saveAs(data, fileName + '_export_' + FormatDisplay.dateTime(new Date()) + EXCEL_EXTENSION);
  }

}

class FormatDisplay {

  static date(value: any, format?: string): string {
    if (value) {
      return moment(value).format(format || 'DD/MM/YYYY');
    }
    return value;
  }

  static dateTime(value: any): string {
    if (value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    }
    return value;
  }

}